<template>
  <div class="pt-6 mb-12">
    <validation-observer ref="validationObserver">
      <v-row justify="center">
        <v-col xl="7">
          <div v-if="$can('create-player-notes')">
            <validation-provider
              v-slot="{ errors }"
              rules="required"
            >
              <rich-text-editor
                v-model="newNote.text"
                class="white elevation-10"
                :placeholder="$t('text_input.notes_about_player.placeholder')"
              />
              <div
                v-if="errors.length > 0"
                class="caption error--text"
              >
                {{ errors[0] }}
              </div>
            </validation-provider>

            <v-row
              no-gutters
              align="center"
              class="mt-3"
            >
              <v-col
                cols="auto"
              >
                <v-switch
                  v-model="newNote.isPlayerVisible"
                  :label="$t('switch.visible_to_player') "
                  dense
                  hide-details
                  class="pa-0 ma-0"
                />
              </v-col>
              <v-col
                cols="auto"
                class="pl-3"
              >
                <v-switch
                  v-model="newNote.isPinned"
                  :label="$t('switch.pinned')"
                  hide-details
                  dense
                  class="pa-0 ma-0"
                />
              </v-col>
              <v-spacer />
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  :loading="newNote.submitting"
                  @click="submit()"
                >
                  {{ $t('training_builder.button.save') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider
            v-if="player.notes.length > 0 && $can('create-player-notes') && $can('view-player-notes')"
            class="mt-4 mb-8"
          />

          <div v-if="$can('view-player-notes')">
            <div v-if="!player.notes || player.notes.length === 0">
              <div class="text-center title grey--text mt-10">
                <div>
                  <v-icon
                    x-large
                    class="grey--text text--lighten-2"
                  >
                    fal fa-notes
                  </v-icon>
                </div>
                <div class="mt-3">
                  {{ $t('notes_empty') }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="mb-16"
            >
              <player-note
                v-for="note in player.notes"
                :key="note.id"
                :note="note"
                :player="player"
                :can-edit="$can('edit-player-notes')"
                :can-delete="$can('delete-player-notes')"
                show-event-name
                class="mb-4"
                @update="$emit('update:player', $event)"
              />
            </div>
          </div>
        </v-col>
        <delete-confirmation-dialog
          :visible.sync="deleteConfirmationDialogVisible"
          :submitting="deleting"
        />
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import DeleteConfirmationDialog from '@/components/dialogs/DeleteConfirmationDialog.vue'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import RichTextEditor from '@/components/inputs/RichTextEditor.vue'
import { PlayerApiService } from '@/data/services'
import PlayerNote from '@/components/players/PlayerNote.vue'

export default {
  name: 'PlayerNotesView',
  components: {
    PlayerNote,
    RichTextEditor,
    DeleteConfirmationDialog
  },
  mixins: [deleteConfirmationMixin],
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newNote: {
        text: '',
        isPinned: false,
        isPlayerVisible: false,
        submitting: false
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    async submit() {
      if (!(await this.$refs.validationObserver.validate())) return

      await this.save()
    },
    async save() {
      this.newNote.submitting = true

      try {
        const result = await PlayerApiService.submitNote(this.player.id, {
          text: this.newNote.text,
          is_pinned: this.newNote.isPinned,
          is_player_visible: this.newNote.isPlayerVisible
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.success'),
          color: 'success'
        })

        this.newNote.text = ''
        this.newNote.isPinned = false
        this.newNote.isPlayerVisible = false

        this.$refs.validationObserver.reset()

        this.$emit('update:player', result.data)
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.error'),
          color: 'error'
        })
      } finally {
        this.newNote.submitting = false
      }
    }
  }
}
</script>

<style scoped>

</style>
